<button type="button" (click)="cancelBankAccount()" class="eba-back">&lsaquo; Back to customer</button>

<payarc-page-header title="Edit Bank Account" subtitle="Update the saved ACH bank account for this customer."></payarc-page-header>

<ng-container *ngIf="topErrorMessage">
  <p class="eba-top-error" *ngFor="let obj of keys1">
    <ng-container *ngFor="let value of obj">{{value}}</ng-container>
  </p>
</ng-container>
<p class="eba-top-error" *ngIf="!topErrorMessage && errorMsgFlag && errorMsg">{{errorMsg}}</p>

<form [formGroup]="editBankAccountForm" (ngSubmit)="editBankAccountForm.valid && editBankAccount()">
  <payarc-section-card heading="Bank account details" class="eba-section">
    <payarc-form-field label="Account number" [required]="true" controlId="account_number"
      [error]="editBankAccountForm.controls['account_number'].errors?.required ? 'Account Number is required.' : (editBankAccountForm.controls['account_number'].errors?.pattern ? 'Account Number is invalid.' : null)">
      <input class="pa-input" name="account_number" id="account_number"
        type="text" inputmode="numeric" placeholder="••••••••••••••••" formControlName="account_number">
    </payarc-form-field>

    <payarc-form-field label="Routing number" [required]="true" controlId="routing_number"
      [error]="editBankAccountForm.controls['routing_number'].errors?.required ? 'Routing Number is required.' : (editBankAccountForm.controls['routing_number'].errors?.pattern ? 'Routing Number is invalid.' : null)">
      <input class="pa-input" name="routing_number" id="routing_number" type="text" inputmode="numeric" placeholder="•••••••••••••"
        formControlName="routing_number" maxlength="9">
    </payarc-form-field>

    <payarc-form-field label="First name" [required]="true" controlId="first_name"
      [error]="editBankAccountForm.controls['first_name'].errors?.required ? 'Account First Name is required.' : null">
      <input class="pa-input" name="first_name" formControlName="first_name" type="text" maxlength="200" id="first_name"/>
    </payarc-form-field>

    <payarc-form-field label="Last name" [required]="true" controlId="last_name"
      [error]="editBankAccountForm.controls['last_name'].errors?.required ? 'Account Last Name is required.' : null">
      <input class="pa-input" name="last_name" formControlName="last_name" type="text" maxlength="200" id="last_name"/>
    </payarc-form-field>

    <payarc-form-field label="Account type" [required]="true" controlId="account_type"
      [error]="editBankAccountForm.controls['account_type'].errors?.required ? 'Account Type is required.' : null">
      <select class="pa-input" formControlName="account_type" id="account_type">
        <option value="">Select Option</option>
        <option *ngFor="let category of categories">{{category}}</option>
      </select>
    </payarc-form-field>
  </payarc-section-card>

  <div class="form-footer">
    <button type="button" payarcButton="secondary" (click)="cancelBankAccount()">Cancel</button>
    <app-loading-button [loadFlag]="loadFlag" [buttonText]="'Update Bank Account'" type="submit"></app-loading-button>
  </div>
</form>
